import { css as t } from "styled-components";
const H = `
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>

  <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap" rel="stylesheet">
`;
var f = /* @__PURE__ */ ((e) => (e.NUNITO_SANS = "Nunito Sans, Helvetica, Arial, sans-serif", e.DM_SANS = "DM Sans, Helvetica, Arial, sans-serif", e))(f || {}), c = /* @__PURE__ */ ((e) => (e[e.REGULAR = 400] = "REGULAR", e[e.BOLD = 700] = "BOLD", e[e.EXTRA_BOLD = 800] = "EXTRA_BOLD", e))(c || {});
const v = t`
  font-family: ${"DM Sans, Helvetica, Arial, sans-serif"};
  font-weight: ${700};
  font-size: 2.5rem;
  line-height: 2.75rem;
`, i = t`
  font-family: ${"DM Sans, Helvetica, Arial, sans-serif"};
  font-size: 1.75rem;
  line-height: 2.25rem;
`, y = t`
  ${i}
  font-weight: ${700};
`, p = t`
  ${i}
  font-weight: ${400};
`, s = t`
  font-family: ${"DM Sans, Helvetica, Arial, sans-serif"};
  font-size: 1.5rem;
  line-height: 2rem;
`, S = t`
  ${s}
  font-weight: ${700};
`, w = t`
  ${s}
  font-weight: ${400};
`, o = t`
  font-family: ${"DM Sans, Helvetica, Arial, sans-serif"};
  font-size: 1.25rem;
  line-height: 1.5rem;
`, L = t`
  ${o}
  font-weight: ${700};
`, A = t`
  ${o}
  font-weight: ${400};
`, a = t`
  font-family: ${"DM Sans, Helvetica, Arial, sans-serif"};
  font-size: 1rem;
  line-height: 1.25rem;
`, D = t`
  ${a}
  font-weight: ${700};
`, $ = t`
  ${a}
  font-weight: ${400};
`, d = t`
  ${$}
  text-decoration: underline;
`, n = t`
  font-family: ${"DM Sans, Helvetica, Arial, sans-serif"};
  font-size: 0.875rem;
  line-height: 1.125rem;
`, M = t`
  ${n}
  font-weight: ${700};
`, h = t`
  ${n}
  font-weight: ${400};
`, B = t`
  ${h}
  text-decoration: underline;
`, r = t`
  font-family: ${"DM Sans, Helvetica, Arial, sans-serif"};
  font-size: 0.75rem;
  line-height: 1rem;
`, O = t`
  ${r}
  font-weight: ${700};
`, g = t`
  ${r}
  font-weight: ${400};
`, k = t`
  ${g}
  text-decoration: underline;
`, l = t`
  ${n}
  text-transform: uppercase;
`, u = t`
  ${l}
  font-weight: ${700};
`, z = t`
  ${l}
  font-weight: ${400};
`;
export {
  a as Body,
  D as BodyHeavy,
  $ as BodyLight,
  d as BodyLink,
  n as Caption,
  M as CaptionHeavy,
  h as CaptionLight,
  B as CaptionLink,
  v as Display,
  f as FontFamily,
  H as FontLink,
  c as FontWeight,
  i as H1,
  y as H1Heavy,
  p as H1Light,
  s as H2,
  S as H2Heavy,
  w as H2Light,
  o as H3,
  L as H3Heavy,
  A as H3Light,
  l as Overline,
  u as OverlineHeavy,
  z as OverlineLight,
  r as Small,
  O as SmallHeavy,
  g as SmallLight,
  k as SmallLink
};
